import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { Provider } from "react-redux";
import { store } from "./redux/store.ts";

// import { getRecipients } from "./redux/reducers/messengerSlice";
// import { fetchLabels } from "./redux/reducers/authSlice";











// Listen for auth token messages from parent window (for embedded usage)
window.addEventListener('message', (event) => {
  // Verify origin for security
  const allowedOrigins = [
    'https://your-main-app-domain.com', // Replace with your actual domain
    'http://localhost:3000', // For development
    'http://localhost:5173', // Vite dev server default port
    'https://console.notifyer-systems.com' // Based on the console URL in your app
  ];
  
  if (!allowedOrigins.includes(event.origin)) {
    return;
  }
  
  if (event.data.type === 'SET_AUTH_TOKEN') {

    // The authToken from URL parameters will be used automatically by getAuthToken() utility
    // No need to do anything special here
  }
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
